import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { SUCCESS_CONFIRMATION_ICON_STACK_CLASS_NAME } from '../../../theme/constants/stack';
import {
  EVALUATION_SENT_DIALOG_CLASS_NAME,
  EVALUATION_SENT_DIALOG_ICON_CLASS_NAME,
  EVALUATION_SENT_DIALOG_DESCRIPTION_CLASS_NAME,
} from '../../../theme/constants/dialog';
import useIsMobile from '../../../hooks/useIsMobile';
import CompactDialog from '../../../components/dialogs/CompactDialog';

const EvaluationSentCompactDialogView = ({
  open,
  onClose,
  title,
  description,
  acceptButtonLabel,
  hideCloseButton,
  warningMessage,
}) => {
  const isMobile = useIsMobile();
  const { branding } = useTheme();

  return (
    <CompactDialog
      open={open}
      onClose={onClose}
      maxWidth={595}
      className={EVALUATION_SENT_DIALOG_CLASS_NAME}
      title={title}
      topIcon={branding.icons.confirmation}
      topIconProps={{
        svgWrapperClassName: SUCCESS_CONFIRMATION_ICON_STACK_CLASS_NAME,
        className: EVALUATION_SENT_DIALOG_ICON_CLASS_NAME,
        sx: { width: 40 },
      }}
      titleColor="success.A800"
      titleBackgroundColor="transparent"
      hideCloseButton={hideCloseButton}
      spacing={3}
    >
      {warningMessage ? (
        <Stack spacing={2} alignItems="center" width="100%">
          <Typography
            variant={isMobile ? 'small_2' : 'small_3'}
            className={EVALUATION_SENT_DIALOG_DESCRIPTION_CLASS_NAME}
            textAlign="center"
            fontWeight={400}
            sx={{ color: 'text.secondary' }}
          >
            <Box
              component="span"
              fontWeight={700}
              sx={{ color: 'text.main' }}
            >
              Importante:{' '}
            </Box>
            {warningMessage.title}
          </Typography>
          <Typography
            variant={isMobile ? 'small_2' : 'small_3'}
            className={EVALUATION_SENT_DIALOG_DESCRIPTION_CLASS_NAME}
            textAlign="center"
            fontWeight={400}
            sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}
          >
            {warningMessage.description}
          </Typography>
        </Stack>
      ) : (
        <Typography
          variant={isMobile ? 'small_2' : 'small_3'}
          className={EVALUATION_SENT_DIALOG_DESCRIPTION_CLASS_NAME}
          textAlign="center"
          fontWeight={400}
          sx={{ color: 'text.secondary' }}
        >
          {description}
        </Typography>
      )}
      <Stack alignItems="center" width="100%">
        <Button
          variant="contained"
          onClick={onClose}
          id="evaluation-sent-dialog-accept"
          size="small"
        >
          {acceptButtonLabel}
        </Button>
      </Stack>
    </CompactDialog>
  );
};

EvaluationSentCompactDialogView.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  acceptButtonLabel: PropTypes.string,
  hideCloseButton: PropTypes.bool,
  warningMessage: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
};

EvaluationSentCompactDialogView.defaultProps = {
  title: undefined,
  description: undefined,
  acceptButtonLabel: 'Aceptar',
  hideCloseButton: true,
  warningMessage: null,
};

export default EvaluationSentCompactDialogView;
